/**
 * Google Analytics 4 integration.
 * Loads gtag.js dynamically, tracks page views and custom events.
 * No PII is sent — only role and hashed user ID.
 */
const MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
let initialized = false;

function loadGtag() {
  if (initialized || !MEASUREMENT_ID) return;
  initialized = true;

  // Default to denied until user consents (POPI Act / GDPR)
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
  });

  gtag('js', new Date());
  gtag('config', MEASUREMENT_ID, {
    send_page_view: false, // we send manually via trackPageView
  });

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);
}

/**
 * Grant analytics consent (call when user accepts cookie/analytics banner).
 */
export function grantAnalyticsConsent() {
  if (!window.gtag) return;
  window.gtag('consent', 'update', { analytics_storage: 'granted' });
}

/**
 * Track a page view. Call on route changes.
 */
export function trackPageView(path) {
  if (!window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: document.title,
  });
}

/**
 * Track a custom event.
 */
export function trackEvent(category, action, label, value) {
  if (!window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value: value,
  });
}

/**
 * Identify a user by role (no PII — no email or name).
 */
export function identifyUser(userId, role) {
  if (!window.gtag) return;
  window.gtag('set', 'user_properties', { user_role: role });
  // Use a simple hash of the userId, not the raw UUID
  window.gtag('config', MEASUREMENT_ID, {
    user_id: userId ? userId.substring(0, 8) : undefined,
  });
}

/**
 * Initialize GA4. Call once on app mount.
 */
export function initAnalytics() {
  loadGtag();
}
